"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DIFF_PAIR_CUSTOM_SUBJECT_TYPE_NAME = void 0;
exports.DIFF_PAIR_CUSTOM_SUBJECT_TYPE_NAME = 'cadstrom.diff_pair';
//# sourceMappingURL=diff-pair-subject.js.map